import { Link } from "react-router-dom";
import { HERO_IMAGES, PORTFOLIO_IMAGES, COMPANY } from "../lib/content";

export default function AboutPage() {
  return (
    <div data-testid="about-page">
      <section className="bg-[var(--crest-black)] text-[var(--crest-cream)] on-dark">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-32 pb-20 grid md:grid-cols-12 gap-10">
          <div className="md:col-span-7">
            <div className="eyebrow" style={{ color: "var(--crest-gold)" }}>— About the Studio</div>
            <h1 className="font-serif text-5xl md:text-7xl tracking-tight mt-6 leading-[1.02]">
              A studio for principals who refuse to look ordinary.
            </h1>
            <p className="mt-8 text-lg leading-relaxed max-w-2xl text-[var(--crest-cream)]/75">
              Upper Crest Image is not a personal styling company. We are a luxury branding,
              marketing, and consulting firm — engineered to elevate organizations, public figures,
              influencers, productions, and corporations across the most-watched rooms in America.
            </p>
          </div>
          <div className="md:col-span-5">
            <img src={HERO_IMAGES[0]} alt="" className="w-full h-[420px] object-cover luxe-img" />
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5 sticky md:top-32 h-fit">
          <div className="eyebrow text-[var(--crest-gold)]">— Studio Ethos</div>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight mt-4">Editorial taste. Strategic discipline.</h2>
        </div>
        <div className="md:col-span-7 space-y-8 text-lg leading-relaxed text-[var(--crest-muted)]">
          <p>
            Every engagement begins with a discovery consultation. From there, we architect a
            customized package — drawing from marketing consulting, branding, creative direction,
            campaign management, production, event design, and public image consulting.
          </p>
          <p>
            We move with the discretion of a private studio and the firepower of an integrated
            agency. Our clients sit at the top of their industries — and they expect their
            partners to operate at the same altitude.
          </p>
          <p>
            Based in Hampton Roads, VA. Engaged nationwide.
          </p>
        </div>
      </section>

      <section className="bg-white border-y border-black/10 py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <div className="eyebrow text-[var(--crest-gold)] mb-6">— Built for the Top</div>
          <h2 className="font-serif text-3xl md:text-5xl tracking-tight max-w-3xl">Who we serve</h2>
          <div className="mt-12 grid md:grid-cols-3 gap-6">
            {[
              ["Public Figures", "Influence stewardship, narrative control, and editorial direction across every channel."],
              ["Politicians & Campaigns", "Campaign architecture, message discipline, surrogate management, and image consulting."],
              ["Non-Profits", "Mission positioning, donor messaging, gala production, and brand evolution."],
              ["Corporations", "Executive image consulting, brand systems, internal communications, and event production."],
              ["Influencers", "Creative direction, business positioning, partnership strategy, and public image refinement."],
              ["TV / Film / Productions", "Production management, brand integration, and editorial promotion."],
            ].map(([title, copy], idx) => (
              <div key={idx} className="border-l-2 border-[var(--crest-gold)] pl-6 py-3" data-testid={`audience-${idx}`}>
                <div className="font-serif text-2xl">{title}</div>
                <p className="text-sm text-[var(--crest-muted)] mt-3 leading-relaxed">{copy}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24">
        <div className="grid md:grid-cols-3 gap-6">
          {PORTFOLIO_IMAGES.slice(0, 3).map((src, i) => (
            <div key={i} className="aspect-[4/5] overflow-hidden">
              <img src={src} alt="" className="luxe-img w-full h-full object-cover" />
            </div>
          ))}
        </div>
        <div className="mt-16 text-center">
          <h3 className="font-serif text-3xl md:text-5xl tracking-tight">Begin with a consultation.</h3>
          <p className="text-[var(--crest-muted)] mt-4">{COMPANY.region}</p>
          <Link to="/book" className="btn-primary mt-8 inline-flex" data-testid="about-cta">Book Now</Link>
        </div>
      </section>
    </div>
  );
}
